import { ReactComponent as OutlineCam16 } from "assets/svg/outline-cam-16.svg";
import { ReactComponent as OutlineCopy } from "assets/svg/outline-copy.svg";
import { ReactComponent as OutlineLocation2 } from "assets/svg/outline-location-2.svg";
import { ReactComponent as OutlineMessageCircleLines2 } from "assets/svg/outline-message-circle-lines-2.svg";
import { ReactComponent as OutlineMicrophone16 } from "assets/svg/outline-microphone-16.svg";
import { isAIAudioSessionForAllPlan } from "components/ai-session-review/utils/getAISessionType";
import IconButton from "components/icon-button";
import SuccessTag from "components/success-tag/SuccessTag";
import messages from "messages";
import { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { isInPersonSession } from "utils/online-offline/isInPersonSession";
import styles from "../../SessionSidesheet.module.scss";

interface LocationSessionDetilsSectionProps {
  appointment: AppointmentWithSeriesInfo & {
    invoice?: InvoiceData;
  };
  trackClick: (name: string) => void;
}

const LocationSessionDetilsSection = ({
  appointment,
  trackClick,
}: LocationSessionDetilsSectionProps) => {
  const [linkCopied, setLinkCopied] = useState(false);
  const copyLinkTaget = useRef(null);

  const copyLink = useCallback(async (twilioUrlCodeForPatient) => {
    try {
      const baseUrl = window.location.origin;
      const fullUrl = `${baseUrl}/video-chat?code=${twilioUrlCodeForPatient}`;
      await navigator.clipboard.writeText(fullUrl);
      setLinkCopied(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }, []);

  return (
    <div className={styles["section"]}>
      <SuccessTag
        target={copyLinkTaget.current}
        show={linkCopied}
        onHide={() => setLinkCopied(false)}
        placement={"top-end"}
        successMsg={"Copied"}
        duration={1000}
      />
      <div className={styles["section__title"]}>{messages.location}</div>

      {isInPersonSession(appointment) ? (
        <>
          <div className={styles["text-with-icon"]}>
            <OutlineLocation2 />
            11 - Office
          </div>
          {isAIAudioSessionForAllPlan(appointment) && (
            <div className={styles["text-with-icon"]}>
              <OutlineMicrophone16 />
              Audio Recorder{" "}
              {appointment.session_recording_type === "individual-patient"
                ? "- Individual"
                : appointment.session_recording_type === "couple"
                ? "- Couple"
                : appointment.session_recording_type === "dictation"
                ? "- Dictation"
                : null}
            </div>
          )}
        </>
      ) : (
        <div className={styles["text-with-icon"]}>
          <OutlineCam16 />
          <div className={"d-flex align-items-center"}>
            {appointment.external_meeting_link
              ? messages.externalTelehealthLink
              : messages.orchidTelehealth}
            <IconButton
              style={{ color: "#007bff" }}
              ref={copyLinkTaget}
              onClick={() => {
                trackClick(
                  appointment.external_meeting_link
                    ? "copy-external-meeting-link"
                    : "copy-orchid-telehealth-link",
                );
                copyLink(appointment.twilio_url_code_for_patient);
              }}
            >
              <OutlineCopy className={"blue mx-2"} /> (Client Link)
            </IconButton>
          </div>
        </div>
      )}

      <div className={styles["text-with-icon"]}>
        <OutlineMessageCircleLines2 />
        <Link
          to={`/pro-dashboard/messages/${appointment.patient?.cognito_sub}`}
          onClick={() => {
            trackClick("send-chat-link");
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {messages.sendMessageToClient}
        </Link>
      </div>
    </div>
  );
};

export default LocationSessionDetilsSection;
